module.exports = "<div class=\"stats\">\n    <h6>{{title | uppercase}}</h6>\n    <p>{{description}}</p>\n</div>\n\n\n"